/* MIcase · Aviso de pago en el carrito · v3
   v1: caja con fondo. Ocupaba media pantalla. Fuera.
   v2: una linea debajo de la nota de impuestos del tema. Mejor, pero quedaban DOS
       avisos diciendo casi lo mismo: "Impuestos, descuentos y envio calculados en la
       pantalla de pago" y el nuestro.
   v3: se fusionan. Dos lineas cortas, y la nota del tema se esconde.

   IMPORTANTE: la nota del tema solo se esconde DESPUES de haber insertado la nuestra,
   y solo si la insercion salio bien. Si este script falla, el cliente sigue viendo la
   nota original. Nunca se esconde algo sin haber puesto el reemplazo.

   Nunca se inserta como hermano del pie del cajon (regla 86): va dentro del pie.
   Cero peticiones a un servicio externo. Los textos vienen del editor.
*/
(function () {
  'use strict';

  var cfg = null;

  function lee() {
    var n = document.getElementById('mcpa-cfg');
    if (!n) return null;
    var t = n.getAttribute('data-texto') || '';
    if (!t) return null;
    return {
      texto: t,
      texto2: n.getAttribute('data-texto2') || '',
      icono: n.getAttribute('data-icono') === '1',
      ocultar: n.getAttribute('data-ocultar') === '1'
    };
  }

  function candado() {
    return '<svg class="mcpa__i" viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false">' +
      '<path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" ' +
      'd="M7 10V7a5 5 0 0 1 10 0v3M5.5 10h13a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 18.5 20h-13A1.5 1.5 0 0 1 4 18.5v-7A1.5 1.5 0 0 1 5.5 10Z"/>' +
      '</svg>';
  }

  function nodo() {
    var d = document.createElement('div');
    d.className = 'mcpa';
    var h = '<p class="mcpa__1">' + (cfg.icono ? candado() : '') + '<span>' + cfg.texto + '</span></p>';
    if (cfg.texto2) h += '<p class="mcpa__2">' + cfg.texto2 + '</p>';
    d.innerHTML = h;
    return d;
  }

  function coloca(pie) {
    if (!pie || pie.querySelector('.mcpa')) return;
    var nota = pie.querySelector('.tax-note, .cart__taxes');
    if (nota && nota.parentNode) {
      nota.parentNode.insertBefore(nodo(), nota.nextSibling);
      if (cfg.ocultar && pie.querySelector('.mcpa')) nota.classList.add('mcpa-off');
    } else {
      pie.insertBefore(nodo(), pie.firstChild);
    }
  }

  function pinta() {
    if (!cfg) return;
    coloca(document.querySelector('#CartDrawer .drawer__footer'));
    coloca(document.querySelector('#main-cart-footer'));
  }

  function arranca() {
    cfg = lee();
    if (!cfg) return;
    pinta();

    /* 2026-08-22 · SE REPONE ANTES DE QUE SE VEA, NO 90 ms DESPUES.
       Antes esto era setTimeout(pinta, 90). El problema: cuando el carrito cambia con el
       cajon abierto, Dawn reemplaza el pie con el HTML del servidor, que trae la nota de
       impuestos del tema y NO trae la nuestra. Con 90 ms de espera el navegador alcanzaba
       a pintar ese estado intermedio: se veia la nota del tema y un instante despues la
       nuestra encima. Eso es exactamente el tipo de repintado que Sebastian pidio limpiar.

       requestAnimationFrame corre JUSTO ANTES del siguiente pintado, asi que el cambio
       entra en el mismo fotograma que el HTML nuevo: no hay ningun cuadro con el estado
       intermedio. Y agrupa solo: el observador se dispara muchas veces durante un
       reemplazo, pero solo queda un aviso pendiente por fotograma.

       No cambia NADA de lo que se pinta ni de las guardas: coloca() sigue saliendo si ya
       hay un .mcpa, y la nota del tema se sigue escondiendo solo DESPUES de haber
       insertado la nuestra y solo si la insercion salio bien. */
    var cajon = document.getElementById('CartDrawer');
    if (cajon && window.MutationObserver) {
      var pedido = false;
      new MutationObserver(function () {
        if (pedido) return;
        pedido = true;
        var ya = window.requestAnimationFrame || function (f) { return setTimeout(f, 0); };
        ya(function () { pedido = false; pinta(); });
      }).observe(cajon, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();